import React, { useMemo, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, Calendar, Users, Plane, Bus, DollarSign } from 'lucide-react';
import { getDestinoImage } from '../utils/destinoImageMapper.mjs';
import OfertaFlashBadge from './OfertaFlashBadge';



// ✅ LISTÓN DE OFERTA - SOLO para descuento principal SIN otros descuentos
const DiscountRibbon = ({ paquete }) => {
  // ════════════════════════════════════════════════════════════════════════════
  // LÓGICA ANTERIOR (COMENTADA)
  // ════════════════════════════════════════════════════════════════════════════
  // const tieneDescuentoPrincipal = paquete.descuento_principal_monto && parseFloat(paquete.descuento_principal_monto) > 0;
  // const tieneDescuento2do = paquete.descuento_2do_pasajero_monto && parseFloat(paquete.descuento_2do_pasajero_monto) > 0;
  // const tieneDescuento3er = paquete.descuento_3er_pasajero_monto && parseFloat(paquete.descuento_3er_pasajero_monto) > 0;
  // const tieneFamilyPlan = paquete.family_plan_activo && parseFloat(paquete.family_plan_descuento) > 0;
  // const tieneDescuento = tieneDescuentoPrincipal || tieneDescuento2do || tieneDescuento3er || tieneFamilyPlan;
  // if (!tieneDescuento) return null;
  // ════════════════════════════════════════════════════════════════════════════
  
  // ✅ NUEVA LÓGICA: Mostrar listón SOLO si:
  // 1. Tiene descuento principal (fijo o porcentaje)
  // 2. NO tiene descuento de 2do pasajero
  // 3. NO tiene descuento de 3er pasajero
  // 4. NO tiene Family Plan activo
  
  const tieneDescuentoPrincipal = paquete.descuento_principal_monto && 
                                   parseFloat(paquete.descuento_principal_monto) > 0;
  
  const tieneDescuento2do = paquete.descuento_2do_pasajero_monto && 
                             parseFloat(paquete.descuento_2do_pasajero_monto) > 0;
  
  const tieneDescuento3er = paquete.descuento_3er_pasajero_monto && 
                             parseFloat(paquete.descuento_3er_pasajero_monto) > 0;
  
  const tieneFamilyPlan = paquete.family_plan_activo && 
                          parseFloat(paquete.family_plan_descuento) > 0;
  /*
  // ✅ SOLO mostrar si tiene descuento principal Y NO tiene otros descuentos
  const mostrarListon = tieneDescuentoPrincipal && 
                        !tieneDescuento2do && 
                        !tieneDescuento3er && 
                        !tieneFamilyPlan;
  
  if (!mostrarListon) return null;
  */
  // ✅ LÓGICA CORREGIDA: Mostrar listón SIEMPRE que tenga descuento principal
  if (!tieneDescuentoPrincipal) return null;

  return (
    <div className="absolute top-0 right-0 z-10 overflow-hidden" style={{ width: '120px', height: '120px' }}>
      <div 
        className="absolute transform rotate-45 bg-red-600 text-white text-center font-bold py-1 shadow-lg"
        style={{
          width: '170px',
          top: '25px',
          right: '-43px',
          fontSize: '13px',
          letterSpacing: '0.5px'
        }}
      >
        OFERTA
      </div>
    </div>
  );
};


function TravelCard({ paquete }) {
  const navigate = useNavigate();
  
  // Calcular precio con descuento
  const tarifaOriginal = parseFloat(paquete.tarifa || 0);
  const flashOferta = paquete.oferta_flash;
  const yaTimeneDescuentoPrincipal = paquete.descuento_principal_monto && parseFloat(paquete.descuento_principal_monto) > 0;
  let precioBase = tarifaOriginal;
  if (flashOferta && !yaTimeneDescuentoPrincipal) {
    if (flashOferta.precio_oferta && parseFloat(flashOferta.precio_oferta) > 0) {
      precioBase = parseFloat(flashOferta.precio_oferta);
    } else if (flashOferta.descuento_porcentaje && parseFloat(flashOferta.descuento_porcentaje) > 0) {
      precioBase = Math.round(tarifaOriginal * (1 - parseFloat(flashOferta.descuento_porcentaje) / 100));
    }
  }
  const tieneFlashDescuento = flashOferta && !yaTimeneDescuentoPrincipal && precioBase !== tarifaOriginal;
  const impuestos = parseFloat(paquete.impuestos || 0);
  
  // ✅ Calcular descuento principal SIN validar fechas
  let descuentoMonto = 0;
  let tieneDescuento = false;
  
  if (paquete.descuento_principal_monto && parseFloat(paquete.descuento_principal_monto) > 0) {
    tieneDescuento = true;
    if (paquete.descuento_principal_tipo === 'porcentaje') {
      descuentoMonto = (precioBase * parseFloat(paquete.descuento_principal_monto)) / 100;
    } else {
      descuentoMonto = parseFloat(paquete.descuento_principal_monto);
    }
  }
  
  // 📅 CÓDIGO COMENTADO - Validación de fechas de vigencia
  // if (paquete.descuento_principal_monto && parseFloat(paquete.descuento_principal_monto) > 0) {
  //   const ahora = new Date();
  //   const desde = paquete.descuento_principal_desde ? new Date(paquete.descuento_principal_desde) : null;
  //   const hasta = paquete.descuento_principal_hasta ? new Date(paquete.descuento_principal_hasta) : null;
  //   
  //   const descuentoActivo = (!desde || ahora >= desde) && (!hasta || ahora <= hasta);
  //   
  //   if (descuentoActivo) {
  //     tieneDescuento = true;
  //     if (paquete.descuento_principal_tipo === 'porcentaje') {
  //       descuentoMonto = (precioBase * parseFloat(paquete.descuento_principal_monto)) / 100;
  //     } else {
  //       descuentoMonto = parseFloat(paquete.descuento_principal_monto);
  //     }
  //   }
  // }
  
  const precioConDescuento = precioBase - descuentoMonto;
  const total = precioConDescuento + impuestos;

  // ✅ NUEVO: Calcular si hay monedas mixtas usando tarifa_adicional
  const precioInfo = useMemo(() => {
    const paqMoneda = (paquete.moneda || '$').trim();
    const tarifaAdicional = parseFloat(paquete.tarifa_adicional || 0);
    const monedaTarifaAdicional = (paquete.moneda_tarifa_adicional || 'U$S').trim();
    
    // Hay monedas mixtas si:
    // - El paquete está en pesos ($)
    // - Hay una tarifa_adicional con valor > 0
    // - La moneda de la tarifa adicional es en dólares (U$S o USD)
    const tieneMonedasMixtas = (paqMoneda === '$' || paqMoneda === 'ARS') && 
                               tarifaAdicional > 0 && 
                               (monedaTarifaAdicional === 'U$S' || monedaTarifaAdicional === 'USD');
    
    console.log('🔍 DEBUG TravelCard - Analizando monedas mixtas:', {
      moneda_paquete: paqMoneda,
      tarifa_adicional: tarifaAdicional,
      moneda_tarifa_adicional: monedaTarifaAdicional,
      tiene_monedas_mixtas: tieneMonedasMixtas,
      paquete_id: paquete.id,
      paquete_titulo: paquete.titulo
    });
    
    return {
      monedaPaquete: paqMoneda,
      tieneMonedasMixtas,
      montoDolares: tieneMonedasMixtas ? tarifaAdicional : 0
    };
  }, [paquete]);
  
  const formatearFecha = (fecha) => {
    if (!fecha) return '';
    return new Date(fecha).toLocaleDateString('es-ES', { 
      day: '2-digit', 
      month: 'short' 
    });
  };

  const handleVerDetalles = () => {
    navigate(`/paquete/${paquete.slug || paquete.id}`);
  };

  // ✅ Estado para manejar la imagen del destino
  const [imagenDestino, setImagenDestino] = useState('/images/placeholder.jpg');

  // ✅ Cargar imagen desde BD (igual que PaqueteDetail)
  useEffect(() => {
    const cargarImagen = async () => {
      // Si tiene carpeta_imagenes y cantidad > 0, usar desde BD
      if (paquete.carpeta_imagenes && paquete.cantidad_imagenes > 0) {
        const version = paquete.imagen_version ? new Date(paquete.imagen_version).getTime() : '';
        const imgUrl = `/images/destinos/${paquete.carpeta_imagenes}/1.webp${version ? `?t=${version}` : ''}`;

        try {
          const response = await fetch(imgUrl, { method: 'HEAD' });
          if (response.ok) {
            setImagenDestino(imgUrl);
          } else {
            // Fallback al mapper
            setImagenDestino(getDestinoImage(paquete.destino_nombre || paquete.destino || paquete.titulo));
          }
        } catch (error) {
          // Fallback al mapper
          setImagenDestino(getDestinoImage(paquete.destino_nombre || paquete.destino || paquete.titulo));
        }
      } else {
        // Sin datos de BD, usar mapper
        setImagenDestino(getDestinoImage(paquete.destino_nombre || paquete.destino || paquete.titulo));
      }
    };
    
    cargarImagen();
  }, [paquete]);
  
  const esSingle = (paquete.singles || '').toLowerCase().trim() === 'si' || 
                   (paquete.singles || '').toLowerCase().trim() === 'sí';

  return (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 max-w-sm mx-auto">
      <div className="relative h-48 overflow-hidden">
        {/* ✅ LISTÓN DE DESCUENTO EN ESQUINA SUPERIOR DERECHA */}
        <DiscountRibbon paquete={paquete} />
        {paquete.oferta_flash && (
          <OfertaFlashBadge oferta={paquete.oferta_flash} lugaresDisponibles={paquete.disponibilidad} />
        )}
        <img
          src={imagenDestino}
          alt={paquete.titulo}
          className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-300"
          loading="lazy"
          width="400"
          height="192"
          onError={(e) => {
            e.target.src = 'https://placehold.co/400x300/2AA8B0/white?text=Sin+Imagen';
          }}
        />
        
        {/* Badge de descuento */}
        {tieneDescuento && (
          <div className="absolute top-3 left-3 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full">
            {paquete.descuento_principal_tipo === 'porcentaje' 
              ? `-${Math.round(parseFloat(paquete.descuento_principal_monto))}%`
              : `-${paquete.moneda || '$'}${Math.round(parseFloat(paquete.descuento_principal_monto)).toLocaleString('es-AR')}`
            }
          </div>
        )}
        
        {paquete.destacado && (
          <div className="absolute top-3 right-3 bg-yellow-500 text-white text-xs font-bold px-2 py-1 rounded-full">
            ⭐ Destacado
          </div>
        )}
      </div>

      <div className="p-4">
        {/* Título y transporte */}
        <div className="mb-3">
          <h3 className="text-lg font-bold text-gray-800 mb-2">
            {paquete.destino_nombre || paquete.destino || paquete.titulo}
          </h3>
          <div className="flex items-center text-gray-600 text-sm mb-3">
            {paquete.transporte === 'Cama' || paquete.transporte === 'Bus' || paquete.transporte === 'Semi-cama' ? (
              <Bus size={14} className="mr-2" />
            ) : (
              <Plane size={14} className="mr-2" />
            )}
            <span>{paquete.transporte || 'Avión'}</span>
          </div>
        </div>


        {/* Info del viaje + PRECIO INDENTADO */}
        <div className="space-y-2 mb-4">
          <div className="flex items-center text-gray-600 text-sm">
            <Calendar size={14} className="mr-2" />
            <span>{paquete.duracion}</span>
          </div>
          
          {paquete.fecha_salida && (
            <div className="flex items-center text-gray-600 text-sm">
              <Calendar size={14} className="mr-2" />
              <span>
                {formatearFecha(paquete.fecha_salida)} 
              </span>
            </div>
          )}
          
          {paquete.disponibilidad && (
            <div className="flex items-center text-gray-600 text-xs">
              <Users size={12} className="mr-2" />
              <span>{paquete.disponibilidad} lugares disponibles</span>
            </div>
          )}

          {/* ✅ PRECIO ALINEADO A LA DERECHA */}
          <div className="flex items-start text-gray-600 text-sm">
            <div className="flex-1">
              {/* Precio total grande */}
                <div className="flex items-baseline justify-start gap-1 mb-1 flex-wrap">
                  {/* ✅ Mostrar monedas mixtas si aplica */}
                  {precioInfo.tieneMonedasMixtas ? (
                    <div>
                      <div className="flex items-baseline gap-1 flex-wrap">
                        {/* Precio tachado si hay descuento */}
                        {precioInfo.tieneDescuentoPrincipal && (
                          <span className="text-sm text-gray-400 line-through mr-2">
                            {paquete.moneda || '$'} {precioInfo.precioOriginal.toLocaleString('es-AR')}
                          </span>
                        )}
                        <span className="text-sm text-gray-600">
                          {paquete.moneda || '$'}
                        </span>
                        <span className="text-2xl font-bold text-[#1E3A5F]">
                          {Math.round(total).toLocaleString('es-AR')}
                        </span>
                        <span className="text-gray-500 text-xs mx-0.5">+</span>
                        <span className="text-2xl font-bold text-blue-600">
                          U$S {Math.round(precioInfo.montoDolares).toLocaleString('es-AR')}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <>
                      
                      <span className="text-sm text-gray-600">
                        {paquete.moneda || '$'}
                      </span>
                      <span className={`text-2xl font-bold ${
                        paquete.moneda === 'U$S' || paquete.moneda === 'USD' 
                          ? 'text-blue-600' 
                          : 'text-[#1E3A5F]'
                      }`}>
                        {Math.round(precioConDescuento).toLocaleString('es-AR')}
                      </span>
                    </>
                  )}
                </div>
              
              {/* Desglose detallado */}
              <div className="text-xs text-gray-500 space-y-0.5">
                {/* Precio ORIGINAL tachado + descuento */}
                {tieneDescuento && (
                  <div className="flex items-center gap-2">
                    <span className="line-through text-gray-400">
                      {paquete.moneda || '$'} {Math.round(tieneFlashDescuento ? precioBase : tarifaOriginal).toLocaleString('es-AR')}
                    </span>
                    <span className="text-green-600 font-semibold">
                      {Math.round(parseFloat(paquete.descuento_principal_monto))}
                      {paquete.descuento_principal_tipo === 'porcentaje' ? '% OFF' : ' OFF'}
                    </span>
                  </div>
                )}
                {tieneFlashDescuento && !tieneDescuento && (
                  <div className="flex items-center gap-2">
                    <span className="line-through text-gray-400">
                      {paquete.moneda || '$'} {Math.round(tarifaOriginal).toLocaleString('es-AR')}
                    </span>
                    <span className="text-red-600 font-semibold">⚡ Flash</span>
                  </div>
                )}
                
                {impuestos > 0 && (
                  <div>+ Impuestos: {paquete.moneda || '$'} {Math.round(impuestos).toLocaleString('es-AR')}</div>
                )}
                
                {/* ✅ Mostrar desglose de dólares si hay monedas mixtas */}
                {precioInfo.tieneMonedasMixtas && (
                  <div className="border-t border-gray-300 pt-0.5 mt-0.5">
                    <div className="text-blue-600 font-semibold">
                      Circuito 1: U$S {Math.round(precioInfo.montoDolares).toLocaleString('es-AR')}
                    </div>
                  </div>
                )}
                
                {/* Aclaración de tarifa */}
                <div className="text-[10px] text-gray-500 mt-1">
                  {esSingle ? 'Tarifa Single' : 'Tarifa por persona en base doble/triple'}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ✅ NUEVO: BADGES DE DESCUENTOS (donde estaba el precio antes) */}
        <div className="flex flex-wrap gap-2 mb-4">
          {/* Descuento 2do pasajero */}
          {paquete.descuento_2do_pasajero_monto && parseFloat(paquete.descuento_2do_pasajero_monto) > 0 && (
            <span className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium rounded-md bg-blue-100 text-blue-700 border border-blue-300">
              <span>👥</span>
              <span>
                {paquete.descuento_2do_pasajero_tipo === 'porcentaje'
                  ? `${Math.round(parseFloat(paquete.descuento_2do_pasajero_monto))}% OFF 2do pasajero`
                  : `$${Math.round(parseFloat(paquete.descuento_2do_pasajero_monto)).toLocaleString()} OFF 2do pasajero`
                }
              </span>
            </span>
          )}
          
          {/* Descuento 3er pasajero */}
          {paquete.descuento_3er_pasajero_monto && parseFloat(paquete.descuento_3er_pasajero_monto) > 0 && (
            <span className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium rounded-md bg-green-100 text-green-700 border border-green-300">
              <span>👨‍👩‍👧</span>
              <span>
                {paquete.descuento_3er_pasajero_tipo === 'porcentaje'
                  ? `${Math.round(parseFloat(paquete.descuento_3er_pasajero_monto))}% OFF 3er pasajero en hab. triple`
                  : `${paquete.moneda || '$'} ${Math.round(parseFloat(paquete.descuento_3er_pasajero_monto)).toLocaleString('es-AR')} OFF 3er pasajero en hab. triple`
                }
              </span>
            </span>
          )}
          
          {/* Family Plan */}
          {paquete.family_plan_activo && parseFloat(paquete.family_plan_descuento) > 0 && (
            <span 
              className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium rounded-md border-2"
              style={{
                backgroundColor: paquete.family_plan_estilo?.color_fondo || '#FF6B6B',
                color: paquete.family_plan_estilo?.color_fuente || '#FFFFFF',
                fontWeight: paquete.family_plan_estilo?.texto_negrita ? 'bold' : 'normal'
              }}
            >
              <span>👨‍👩‍👧‍👦</span>
              <span>
                {paquete.family_plan_tipo === 'porcentaje'
                  ? `Family Plan: ${Math.round(parseFloat(paquete.family_plan_descuento))}% OFF menores`
                  : `Family Plan: $${Math.round(parseFloat(paquete.family_plan_descuento)).toLocaleString()} OFF menores`
                }
              </span>
            </span>
          )}
        </div>

        <button 
          onClick={handleVerDetalles}
          className="w-full bg-[#2AA8B0] hover:bg-[#258A91] text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200"
        >
          Ver detalles
        </button>
      </div>
    </div>
  );
}

export default TravelCard;